import React from "react";
import classNames from "classnames";

import useFilters from "@/hooks/useFilters";

import Button from "@/components/botanic/Button";
import Carousel from "@/components/botanic/Carousel";

import StrainTile from "../botanic/StrainTile";
import promotedStrains from "./promoted-strains.json";

type PromotedStrain = {
  category: string;
  strainName: string;
  symbol: string;
};

const PromotedStrainCarousel: React.FC<{
  asLink?: boolean;
  className?: string;
  onClick?: (strain: PromotedStrain) => void;
  title?: string;
}> = ({ asLink, className, onClick, title }) => {
  const { selectFilterValue } = useFilters();
  const selectedStrain = selectFilterValue("strain_name");

  return (
    <Carousel
      title={title ? <h2 className="heading--m">{title}</h2> : undefined}
      cardsPerSlide={6}
      mobileCardWidth={155}
      className={className}
    >
      {promotedStrains.map((strain) => {
        const strainIsSelected = strain.strainName === selectedStrain;

        return (
          <Button
            key={strain.strainName}
            href={
              asLink
                ? `/search/shop/promoted-strains?strain_name=${encodeURIComponent(
                    strain.strainName as string,
                  )}&deal_active=true`
                : undefined
            }
            onClick={() => onClick?.(strain)}
            className="bg-transparent !px-none !py-none rounded-none"
          >
            <div className="flex justify-center">
              <StrainTile
                name={strain.strainName}
                symbol={strain.symbol}
                category={strain.category}
                className="h-[184px] w-[135px]"
              />
            </div>
            <div
              className={classNames("font-bold text-center mt-4 text-sm", {
                "text-default": !strainIsSelected,
                "text-green": strainIsSelected,
              })}
            >
              {strain.strainName}
            </div>
          </Button>
        );
      })}
    </Carousel>
  );
};

export default PromotedStrainCarousel;
